import React, { useContext } from 'react'
import styled from 'styled-components'
import { Box, Flex, Image, NameList, ResponsiveSVG } from 'ui/acro'
import { AlomovesIconSVG } from 'images/latest'
import LinearProgressChart from '../ProgramsInProgress/LinearProgressChart'
import { storeEventInLocalStorage } from 'gtm/pushEvents'
import { useWindowResize } from 'hooks'
import { useInRouterContext } from 'react-router-dom'
import CommonLink from 'components_v2/CommonLink'
import { ProgramsHomeContext } from 'components_v2/page_context'

const TextContainer = styled(Flex)({
  flexDirection: 'column',
  position: 'absolute',
  bottom: '16px',
  left: '16px',
  gap: '12px',
  width: '95%',
  zIndex: '10'
})

const Title = styled('div')({
  color: '#FFF',
  fontSize: '28px',
  fontWeight: 600,
  fontFamily: 'Proxima-nova',
  textTransform: 'uppercase',
  lineHeight: '135%',
  letterSpacing: '-0.84px'
})

const SubTitle = styled('div')({
  color: '#FFF',
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: 'Proxima-nova',
  lineHeight: '24px',
  letterSpacing: '0.352px'
})

const StopProgramLink = styled('div')({
  color: '#000',
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: 'Proxima-nova',
  textDecoration: 'underline',
  lineHeight: '24px',
  letterSpacing: '0.352px'
})

const Main = styled(Flex)`
  .no-image {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f2f2f2;
    aspect-ratio: 16/9;
  }
  img {
    width: stretch;
  }
`
const MainLink = styled(CommonLink)`
  ${Main}
`

const ProgramCardLarge = ({
  totalClassesCount,
  coaches,
  completedClassesCount,
  primaryCategory,
  title,
  slug,
  style,
  alignBox,
  coverPhoto,
  eventName
}) => {
  const { handleStopProgramClick } = useContext(ProgramsHomeContext)
  const { width } = useWindowResize()
  const isMobile = width < 768
  const insideRouter = useInRouterContext()

  const image = coverPhoto?.url

  const pushEvent = (e) => {
    if (!eventName) {
      return
    }
    const coachNames = coaches
      ?.map((item) => `${item.firstName} ${item.lastName}`)
      .join(', ')

    const event_data = {
      event: eventName,
      availability: 'ALO_ACCESS',
      instructor: coachNames,
      series: title,
      style: style
    }
    if (insideRouter) {
      window.dataLayer ||= []
      window.dataLayer.push(event_data)
      return
    }
    storeEventInLocalStorage(event_data)
  }

  return (
    <MainLink
      flexDirection='column'
      alignItems={alignBox}
      position='relative'
      className={'swiper-slide unstyled'}
      onClick={pushEvent}
      to={`/series/${slug}`}
      style={{
        minWidth: isMobile ? '100%' : '28%',
        marginTop: '16px'
      }}
    >
      {image ? (
        <Box position='relative' mb={['8px', '10px']}>
          <Image
            src={image}
            objectFit='cover'
            position='absolute'
            aspectRatio='16/9'
            top='0'
            left='0'
            style={{ aspectRatio: '16/9' }}
            className='program-image'
          />
          <Box
            position='absolute'
            top='0'
            left='0'
            width='100%'
            height='100%'
            style={{
              backgroundImage:
                'linear-gradient(to bottom, rgba(255,255,255,0.1), rgba(0,0,0,0.45))'
            }}
            pointerEvents='none'
          />
          <TextContainer>
            <SubTitle>{primaryCategory?.title}</SubTitle>
            {title && <Title>{title}</Title>}

            {coaches && (
              <SubTitle>
                <NameList people={coaches} />
              </SubTitle>
            )}
          </TextContainer>
        </Box>
      ) : (
        <Box className='no-image' mb={['8px', '10px']}>
          <ResponsiveSVG
            width={['68px', '68px', '130px', '130px']}
            height={['68px', '68px', '130px', '130px']}
            SVG={AlomovesIconSVG}
            className='no-thumbnail'
          />
        </Box>
      )}
      <LinearProgressChart
        totalClasses={totalClassesCount}
        completedClasses={completedClassesCount}
        showText={true}
      />

      <StopProgramLink
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          handleStopProgramClick?.(slug)
        }}
      >
        Stop Program
      </StopProgramLink>
    </MainLink>
  )
}

export default ProgramCardLarge
